/* refonte-home.js - genere depuis CLEAN-TWIN-HOME.html - NE PAS EDITER A LA MAIN */
(function(){
  var RF = document.getElementById('rf-home') || document;
  var doc = document.documentElement;
  doc.classList.add('js');
  var rm = matchMedia('(prefers-reduced-motion: reduce)').matches;
  var tl = document.getElementById('tl'), steps = tl ? tl.querySelectorAll('.step') : [];

  function showAll(){
    RF.querySelectorAll('[data-rv]').forEach(function(n){ n.classList.add('on'); });
    if(tl){ tl.classList.add('on'); steps.forEach(function(s){ s.classList.add('on'); }); }
  }

  /* 1. Reveal au scroll */
  var io = new IntersectionObserver(function(es){
    es.forEach(function(e){ if(e.isIntersecting){ e.target.classList.add('on'); io.unobserve(e.target); } });
  }, {threshold:.12, rootMargin:'0px 0px -40px 0px'});
  RF.querySelectorAll('[data-rv]').forEach(function(n){ io.observe(n); });

  /* 2. Timeline (ligne + étapes en cascade) */
  if(tl){
    var io2 = new IntersectionObserver(function(es){
      es.forEach(function(e){
        if(!e.isIntersecting) return;
        tl.classList.add('on');
        steps.forEach(function(s,i){ s.style.transitionDelay = Math.min(i*170,680)+'ms'; s.classList.add('on'); });
        io2.disconnect();
      });
    }, {threshold:.2, rootMargin:'0px 0px -60px 0px'});
    io2.observe(tl);
  }

  /* Filet de sécurité : onglet caché ou IO inactif, on n'ampute jamais le contenu */
  if(rm || document.visibilityState === 'hidden') showAll();
  addEventListener('visibilitychange', function(){ if(document.visibilityState === 'hidden') showAll(); });
  setTimeout(function(){
    var last = RF.querySelectorAll('[data-rv]');
    if(last.length && !last[0].classList.contains('on')) showAll();
  }, 3000);

  /* 3. Onglets de recherche */
  var tabs = RF.querySelectorAll('.tab'), input = document.getElementById('q'),
      u = RF.querySelector('.tabs__u'), soon = document.getElementById('soonMsg'), timer;
  function slide(t){ if(!u) return; var p=t.parentElement.getBoundingClientRect(), r=t.getBoundingClientRect();
    u.style.setProperty('--tw', r.width+'px'); u.style.setProperty('--tx', (r.left-p.left)+'px'); }
  tabs.forEach(function(t){
    t.addEventListener('click', function(){
      if(t.dataset.soon){ soon.classList.add('on'); clearTimeout(timer); timer=setTimeout(function(){soon.classList.remove('on')},4200); return; }
      tabs.forEach(function(x){ x.setAttribute('aria-selected','false'); });
      t.setAttribute('aria-selected','true');
      if(t.dataset.ph) input.placeholder = t.dataset.ph;
      soon.classList.remove('on'); slide(t); input.focus({preventScroll:true});
    });
  });
  var act = RF.querySelector('.tab[aria-selected=true]');
  if(act) requestAnimationFrame(function(){ slide(act); });
  addEventListener('resize', function(){ var a=RF.querySelector('.tab[aria-selected=true]'); if(a) slide(a); }, {passive:true});

  /* 4. Spotlight curseur du hero (desktop, hors reduced-motion) */
  var hero = document.getElementById('hero');
  if(hero && !rm && matchMedia('(hover: hover)').matches){
    hero.classList.add('spot');
    var raf=0, x=50, y=28;
    hero.addEventListener('mousemove', function(e){
      var r=hero.getBoundingClientRect();
      x=((e.clientX-r.left)/r.width)*100; y=((e.clientY-r.top)/r.height)*100;
      if(!raf) raf=requestAnimationFrame(function(){ hero.style.setProperty('--mx',x+'%'); hero.style.setProperty('--my',y+'%'); raf=0; });
    }, {passive:true});
  }
})();
/* menu mobile */
(function(){
  var hd = document.querySelector('[id^="rf-"] .hd') || document.querySelector('.hd');
  if(!hd) return;
  var b = hd.querySelector('.brg');
  if(!b) return;
  b.addEventListener('click', function(){
    var open = hd.classList.toggle('is-open');
    b.setAttribute('aria-expanded', String(open));
    b.setAttribute('aria-label', open ? 'Fermer le menu' : 'Ouvrir le menu');
  });
  hd.querySelectorAll('.nav a').forEach(function(a){
    a.addEventListener('click', function(){
      hd.classList.remove('is-open'); b.setAttribute('aria-expanded','false');
    });
  });
  document.addEventListener('click', function(e){
    if(hd.classList.contains('is-open') && !hd.contains(e.target)){
      hd.classList.remove('is-open'); b.setAttribute('aria-expanded','false');
    }
  });
})();
